import merge from 'ts-deepmerge';
import { ThemeType, BaseThemeType } from '../../@types/styled-components';

const baseTheme: BaseThemeType = {
  fonts: {
    primary: "'Roboto', sans-serif",
    secondary: "'Open Sans', sans-serif",
  },
  fontSizes: {
    small: '0.8rem',
    medium: '1rem',
    large: '1.5rem',
    xlarge: '2rem',
  },
  spacing: {
    xsmall: '4px',
    small: '8px',
    medium: '16px',
    large: '32px',
    xlarge: '64px',
  },
  breakpoints: {
    xs: '480px',
    sm: '768px',
    md: '992px',
    lg: '1200px',
  },
  transitions: {
    default: 'all 0.3s ease-in-out',
  },
};

const lightTheme: ThemeType = merge(baseTheme, {
  shadows: {
    default: '0px 1px 5px rgba(0, 0, 0, 0.15)',
    hover: '0px 2px 10px rgba(0, 0, 0, 0.2)',
    active: '0px 4px 15px rgba(0, 0, 0, 0.3)',
  },
  colors: {
    primary: '#3498db',
    secondary: '#2ecc71',
    error: '#e74c3c',
    warning: '#f39c12',
    green: '#29A85C',
    blue300: '#007AFF',
  },
  background: {
    default: '#ffffff',
    hover: '#e4e7ea',
  },
  link: {
    default: '#757575',
    hover: '#444444',
    decoration: 'underline',
  },
  text: {
    primary: '#1C1B1F',
    secondary: '#555',
    disabled: '#aaa',
    hint: '#888',
    hover: '#007aff',
  },
  border: {
    default: '#ddd',
  },
});

const darkTheme: ThemeType = merge(baseTheme, {
  shadows: {
    default: '0px 1px 5px rgba(0, 0, 0, 0.15)',
    hover: '0px 2px 10px rgba(0, 0, 0, 0.2)',
    active: '0px 4px 15px rgba(0, 0, 0, 0.3)',
  },
  colors: {
    primary: '#3498db',
    secondary: '#2ecc71',
    error: '#e74c3c',
    warning: '#f39c12',
    green: '#29A85C',
    blue300: '#007AFF',
  },
  background: {
    default: '#1C1B1F',
    hover: '#454545',
  },
  link: {
    default: '#ced0d1',
    hover: '#ffffff',
    decoration: 'underline',
  },
  text: {
    primary: '#FFFFFF',
    secondary: '#555',
    disabled: '#aaa',
    hint: '#888',
    hover: '',
  },
  border: {
    default: '#ddd',
  },
});

export const themes: { light: ThemeType; dark: ThemeType } = {
  light: lightTheme,
  dark: darkTheme,
};
